"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFieldsetTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
const constants_1 = require("../../helpers/constants");
exports.StyledFieldsetTitle = styled_components_1.default.tr `
    td {
        padding: calc(${helpers_1.SPACING_M} - ${constants_1.stylesConfig.paddingBottomLastTd}) 0 ${helpers_1.SPACING_M};
    }

    td > div {
        padding-left: ${helpers_1.SPACING_S};
        font-weight: ${helpers_1.BASE_FONT_BOLD_WEIGHT};
        line-height: ${helpers_1.SPACING_XL};
        background-color: ${({ theme }) => theme.colorBackgroundNeutralLight};
    }
`;
//# sourceMappingURL=FieldsetTitle.styles.js.map